import { styled, Typography } from '@mui/material';
import { Link } from 'react-router-dom';

export const MyTasksList = styled('div')({
  display        : 'flex',
  justifyContent : { lg: 'center' },
  alignItems     : 'center',
  flexWrap       : 'wrap',
  gap            : '16px',
});

export const MyTasksHeader = styled('div')({
  display        : 'flex',
  justifyContent : 'space-between',
  alignItems     : 'center',
  marginBottom   : '13px',
});

export const Title = styled(Typography)({
  fontFamily : 'Montserrat',
  fontWeight : '700',
});

export const ViewMoreTasksLink = styled(Link)(({ theme }) => ({
  textDecoration : 'none',
  color          : theme.palette.primary.lightBlue1,
  fontSize       : '14px',
  fontFamily     : 'Montserrat',
  fontWeight     : '700',
  '& span'       : {
    marginRight : '10px',
  },
}));

export const SETTING_UP_TASKS_MESSAGE =
  'Please wait. We are setting up your tasks. This might take up to 45 seconds. This page will refresh every 15 seconds until your tasks are loaded.';

export const TASKS_SETUP_FAILED_MESSAGE =
  'Your tasks are taking longer than anticipated to load. Please wait and refresh this page in 15 minutes to view your tasks.';
